import type { ReactNode } from "react";
import type { Cluster } from "@little-finds/core";
import { ChevronRight } from "lucide-react";
import { clusterCoordinates } from "../clusterNavigation";

export function ResultsBrowser({
  clusters,
  storeCount,
  onCluster,
  storeList,
  emptyState,
}: {
  clusters: Cluster[];
  storeCount: number;
  onCluster: (cluster: Cluster) => void;
  storeList: ReactNode;
  emptyState: ReactNode;
}) {
  return (
    <>
      {clusters.length > 0 && (
        <section
          className="cluster-results"
          aria-label="Explore matching areas"
        >
          <h3>Explore matching areas</h3>
          <p>
            Choose an area to see its shops. This works even when the map is
            unavailable.
          </p>
          <ul>
            {clusters.map((cluster) => (
              <li key={cluster.id}>
                <button
                  type="button"
                  className="cluster-result"
                  onClick={() => onCluster(cluster)}
                >
                  <span>
                    <strong>
                      {cluster.count} matching{" "}
                      {cluster.count === 1 ? "shop" : "shops"}
                    </strong>
                    <small>Near {clusterCoordinates(cluster)}</small>
                  </span>
                  <ChevronRight size={18} aria-hidden="true" />
                </button>
              </li>
            ))}
          </ul>
        </section>
      )}
      {storeCount > 0 ? storeList : clusters.length === 0 ? emptyState : null}
    </>
  );
}
